import { Inbox, type LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

export interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
  /** extra buttons or a hint */
  children?: ReactNode
  compact?: boolean
}

/** Empty = EmptyState (CRM kit rule 5). Says what is missing and what to do about it. */
export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  actionLabel,
  onAction,
  children,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center px-4 text-center ${compact ? 'py-6' : 'py-12'}`}
      role="status"
    >
      <div
        className={`mb-3 flex items-center justify-center rounded-full bg-primary-soft ${compact ? 'h-10 w-10' : 'h-14 w-14'}`}
      >
        <Icon size={compact ? 18 : 26} className="text-primary" />
      </div>
      <h3 className="text-sm font-bold text-default">{title}</h3>
      {description && <p className="mt-1.5 max-w-md text-xs leading-relaxed text-muted">{description}</p>}
      {actionLabel && onAction && (
        <button type="button" onClick={onAction} className="btn btn-primary mt-4">
          {actionLabel}
        </button>
      )}
      {children && <div className="mt-3 flex flex-wrap justify-center gap-2">{children}</div>}
    </div>
  )
}
